




























































































































































































































































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import PageLayout from '@/components/page/PageLayout.vue'
import { TOKEN } from '@/store/mutation-types'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'
import { columns } from './auditConfig'
import listMixins from '@/mixins/list'
import { download } from '@/utils/util'
import RevisitApi from '@/api/revisit'
import addResurvey from './addResurvey/addResurvey.vue'
import addMotion from './addResurvey/addMotion.vue'
import actionCol from './actionCol.vue'
import { RESURVEY, MOTION, NEW_MOTION, SHOU_HOU, WEI_JUE } from '@/utils/const'
import moment from 'moment'
import { formatDate } from '@/web-task/filter'

@Component({
	name: 'returnVisitList',
	components: {
		PageLayout,
		addResurvey,
		addMotion,
		actionCol,
	},
})
export default class TasksList extends Mixins(listMixins) {
	private columns: object = columns
	private data: any[] = []

	private timer: any = ''
	private exportingList: boolean = false

	private goToDetail(row: any) {
		return `/AiiTasks/TasksDetail/${row.orderId}/${row.taskType}`
	}

	public getList() {
		return RevisitApi.getAuditList(this.getForm()).then((res: any) => {
			this.data = res.data.retList
			this.data.forEach(item => {
				this.$set(
					item,
					'orderCreateTime',
					formatDate(new Date(item.orderCreateTime), 'YYYY-MM-DD')
				)
			})
			this.total = res.data.count
			this.resetSelected()
		})
	}

	private get initialTaskRange() {
		return [
			moment()
				.startOf('day')
				.subtract(2, 'month'),
			moment().startOf('day'),
		]
	}

	// todo activated
	public mounted() {
		this.$store.dispatch('setting/initPartnerTree')
		this.$store.dispatch('setting/initAreas')
		this.getList()
	}

	public activated() {
		this.$store.dispatch('setting/initPartnerTree')
		this.$store.dispatch('setting/initAreas')
		this.getList()
	}

	private deactivated() {
		clearInterval(this.timer)
	}

	private onTaskAdd() {
		this.resetPage()
		this.getList()
	}

	private getForm() {
		const form: any = this.getSearchValues()
		if (form.taskRangeTime) {
			form.startCreateTime =
				form.taskRangeTime[0] && form.taskRangeTime[0].format('YYYY-MM-DD')
			form.endCreateTime =
				form.taskRangeTime[1] && form.taskRangeTime[1].format('YYYY-MM-DD')
			delete form.taskRangeTime
		}
		form.orderStatus = form.orderStatus.filter((item: any) => item !== '')

		return form
	}

	private goAuditDetail(row: any) {
		// 有无审核人 字段确认
		if (
			row.checkorName &&
			row.checkor != this.$store.state.user.userInfo.userId
		) {
			this.$confirm({
				title: '提示',
				content: `当前审核客服为${row.checkorName},确定审核该订单吗？`,
				onOk: () => {
					this.claim(row, '1')
				},
			})
		} else if (!row.checkorName) {
			this.$confirm({
				title: '提示',
				content: '确认审核该订单吗 ?',
				onOk: () => {
					this.claim(row, '0')
				},
			})
		} else {
			this.claim(row, '0')
		}
	}

	private goFollowUpDetail(row: any) {
		this.$confirm({
			title: '提示',
			content: '确认跟进该订单吗?',
			onOk: () => {
				this.followUp(row)
			},
		})
	}

	private async followUp(row: any) {
		await RevisitApi.claim(row.orderId, row.recordType, '0').then(
			(res: any) => {
				if (res.code == 200) {
					this.getList()
					if (row.recordType === 'checkPartnerCancel') {
						this.$router.push(
							`/partner/orderDetail/2/${row.orderId}/${row.dispatchId}`
						)
					}
				}
			}
		)
	}

	private async claim(row: any, force: string) {
		await RevisitApi.claim(row.orderId, row.recordType, force).then(
			(res: any) => {
				if (res.code == 200) {
					this.getList()
					this.$router.push(
						`/returnVisit/auditDetail/${row.orderId}/${row.taskType}?canChecked=${row.canChecked}`
					)
				}
			}
		)
	}

	private exportList() {
		this.exportingList = true
		RevisitApi.exporAuditList(this.getForm())
			.then((res: any) => {
				const blob: any = new Blob([res.data])
				download(blob, res.filename)
			})
			.finally(() => {
				this.exportingList = false
			})
	}
}
